export default __webpack_public_path__ + "static/media/zones.ed39dd5b.svg";